import { DEFAULT_TENANT, NON_TENANT_PREFIXES } from '../constant/constants';

export const getTenantCode = () => {
  const [subdomain] = window.location.hostname.split('.');
  const parts = subdomain.split('-');

  const [prefix, keyword] = parts;

  const isTenantPrefix = keyword === 'rewards' && !NON_TENANT_PREFIXES.includes(prefix);

  return isTenantPrefix ? prefix : DEFAULT_TENANT;
};

export const getEnvironment = () => {
  const { hostname } = window.location;
  const envMatch = hostname.match(/^[^-]+-rewards-([^.]+)/);
  return envMatch ? envMatch[1] : 'local';
};

export const isTenantValid = tenantCode => {
  return tenantCode && typeof tenantCode === 'string' && tenantCode.length > 0;
};
